import React from 'react';
import { JobFormCard } from './basic/JobFormCard';
import { ExecutionDetailResponseBody } from '@lct-jobs/core';
import validator from '@rjsf/validator-ajv8';

export interface JobOutputProps {
  jobExecution?: ExecutionDetailResponseBody;
}

export const JobOutputBox: React.FC<JobOutputProps> = (props) => {
  const execution = props.jobExecution;

  return (
    <JobFormCard
      title="Job Output"
      schema={execution?.outputSchema ?? {}}
      formData={execution?.jobOutput}
      validator={validator}
    />
  );
};
